/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const SearchIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 14 14' {...props}>
			<path
				d='m13.776 12.966-3.59-3.59a5.742 5.742 0 1 0-.811.811l3.59 3.59Zm-8.025-2.634a4.586 4.586 0 1 1 4.581-4.581 4.586 4.586 0 0 1-4.581 4.581Z'
				fill={color}
			/>
		</svg>
	)
}

export default SearchIcon
